// eslint-disable-next-line max-len
import { VehicleMaintenanceSchedule } from '@quorum/models/xs-resource';

import { createSelector, createFeatureSelector } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface MaintenanceScheduleState extends EntityState<VehicleMaintenanceSchedule> {}

export const maintenanceScheduleAdapter: EntityAdapter<VehicleMaintenanceSchedule> = createEntityAdapter<
  VehicleMaintenanceSchedule
>({
  selectId: (maintenanceSchedule: VehicleMaintenanceSchedule) => maintenanceSchedule.vehicleId
});

export const initialState: MaintenanceScheduleState = maintenanceScheduleAdapter.getInitialState({});
export const maintenanceScheduleFeatureSelector = createFeatureSelector<any>('vehicleMaintenance');
export const maintenanceScheduleSelector = createSelector(
  maintenanceScheduleFeatureSelector,
  (state: any) => state.maintenanceSchedule
);
export const { selectIds, selectEntities, selectAll, selectTotal } = maintenanceScheduleAdapter.getSelectors(
  maintenanceScheduleSelector
);
